/**
 * Product Cards List Scrollable - Handles horizontal scroll with dot navigation
 */

class ProductCardsListScrollable {
  constructor(container) {
    this.container = container;
    this.id = container.getAttribute('data-scrollable-container');
    this.dotsContainer = document.querySelector(`[data-dots-container="${this.id}"]`);
    
    if (!this.dotsContainer) return;
    
    this.dots = Array.from(this.dotsContainer.querySelectorAll('.product-cards-list-dot'));
    this.currentPage = 0;
    
    this.init();
  }

  init() {
    // Dot click handlers
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.scrollToPage(index);
      });
    });

    // Scroll event to update active dot
    this.container.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Update on resize
    window.addEventListener('resize', this.debounce(() => {
      this.updateActiveDot();
    }, 200));
  }

  scrollToPage(pageIndex) {
    const containerWidth = this.container.offsetWidth;
    const scrollLeft = pageIndex * containerWidth;
    
    this.container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
    
    this.updateActiveDot(pageIndex);
  }

  handleScroll() {
    const containerWidth = this.container.offsetWidth;
    const scrollLeft = this.container.scrollLeft;
    const currentPage = Math.round(scrollLeft / containerWidth);
    
    if (currentPage !== this.currentPage) {
      this.currentPage = currentPage;
      this.updateActiveDot(currentPage);
    }
  }

  updateActiveDot(pageIndex = null) {
    if (pageIndex === null) {
      const containerWidth = this.container.offsetWidth;
      const scrollLeft = this.container.scrollLeft;
      pageIndex = Math.round(scrollLeft / containerWidth);
    }
    
    this.dots.forEach((dot, index) => {
      if (index === pageIndex) {
        dot.classList.add('product-cards-list-dot--active');
      } else {
        dot.classList.remove('product-cards-list-dot--active');
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize all scrollable product card lists
document.addEventListener('DOMContentLoaded', () => {
  const scrollableContainers = document.querySelectorAll('[data-scrollable-container]');
  scrollableContainers.forEach(container => {
    new ProductCardsListScrollable(container);
  });
});

// Re-initialize on Shopify section load (for theme editor)
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const scrollableContainers = event.target.querySelectorAll('[data-scrollable-container]');
    scrollableContainers.forEach(container => {
      new ProductCardsListScrollable(container);
    });
  });
}
